import $ from 'jquery';

function Placeholder(element) {
  this.element = element;
  this.$element = $(element);
  this.init();
}

Placeholder.prototype = {
  init() {
    const label = this.$element.find('label').text();
    if (label.length) {
      this.$element.find('input').attr('placeholder', label);
    }
  },
};

export default Placeholder;



// WEBPACK FOOTER //
// ./Placeholder.js